export default function () {

    return (x) => Math.sin(Math.PI * x);
};
